import React, { useEffect, useRef, useState } from 'react';
import SvgSearch from 'src/assets/svg/SvgSearch.svg';

const SearchBar = ({
    placeholder = 'Search reviews',
    onSearch,
    onClear,
    autoFocus = false,
    disabled = false,
    initialValue = '',
    className = '',
    onClick,
}) => {
    const [searchValue, setSearchValue] = useState(initialValue);
    const inputRef = useRef(null);

    useEffect(() => {
        if (autoFocus && inputRef.current) {
            inputRef.current.focus();
        }
    }, [autoFocus]);

    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchValue(value);

        // If user clears the input manually (including native search clear button), trigger search with empty string
        if (value === '' && onClear) {
            onClear();
        }
    };

    const handleKeyPress = (e) => {
        if ((e.key === 'Enter' || e.key === 'Search') && onSearch) {
            e.preventDefault();
            onSearch(searchValue.trim());
        }
    };

    const handleSearchClick = () => {
        if (onSearch) {
            onSearch(searchValue.trim());
        }
    };

    const handleContainerClick = () => {
        if (disabled && onClick) {
            onClick();
        }
    };

    return (
        <div className={`search-bar ${className}`} onClick={disabled ? handleContainerClick : undefined}>
            <div className="search-input-container">
                <SvgSearch
                    className="search-icon"
                    onClick={disabled ? undefined : handleSearchClick}
                    style={{ cursor: disabled ? 'default' : 'pointer' }}
                />
                <input
                    ref={inputRef}
                    type="search"
                    className="search-input"
                    placeholder={placeholder}
                    value={searchValue}
                    onChange={handleInputChange}
                    onKeyPress={handleKeyPress}
                    disabled={disabled}
                />
            </div>
        </div>
    );
};

export default SearchBar;
